<template>
  <table-view ref="table" class="h-full"
    :get-params-path="getParamsPathAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :payload-single-id="PayloadSingleId"
    :lista-acciones="listaAcciones"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction" />
</template>

<script>
import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/DistributorsFilter.vue'
import { getDistributorsPag } from '@/services/distributors/getDistributorsPag'
import { getDistributorsExcel } from '@/services/distributors/getDistributorsExcel'

export default {
  name: 'distributors-list-view',
  components: {
    TableView
  },
  data () {
    return {
      idVista: 55,
      FilterPanel: CustomFilter,
      vuexnamespace: 'distributors',
      headerTitle: i18n.t('distributors.header'),
      headerIcon: 'config',
      routeName: 'configurations/distributors/details',
      excelName: `${i18n.t('distributors.header').toLowerCase()}.xlsx`,
      breadcrumbName: 'Nombre',
      PayloadSingleId: 'IdDistribuidor',
      listaAcciones: [
        // { IdAccion: 800, Descripcion: 'Activar', icon: 'check' },
        // { IdAccion: 801, Descripcion: 'Desactivar', icon: 'cross' }
      ],
      footerAcciones: [{ text: i18n.t('distributors.new'), icon: 'plus', handler: this.goToNewDistributor }],
      processMessage: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('distributors.header').toLowerCase() })
    }
  },
  mounted () {
  },
  computed: {
    tiposDistribuidor: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR']
    },
    tiposProvisionamiento: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO']
    },
  },
  methods: {
    getParamsPathAux (data) {
      return { id: data.IdDistribuidor }
    },
    getParamsAux (data) {
      return { 
        Nombre: data.name ? data.name.value : null,
        idTipoDistribuidor: data.tipoDistribuidor ? data.tipoDistribuidor.value : null,
        idTipoProvisionamiento: data.tipoProvisionamiento ? data.tipoProvisionamiento.value : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getDistributorsPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      try {
        return await getDistributorsExcel(objOrder, params)
      } catch (error) {}
    },
    goToNewDistributor: function () {
      this.$router.push({ name: 'configurations/distributors/details', params: { id: -1 } })
    },
    executeAction: async function (action, selected = []) {
      if (selected.length) {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    }
  },
}
</script>

<style scoped>

</style>
